export const DATA_ATTRIBUTE_ACTIVE = 'data-info-toggle-active';

const InfoToggle = (triggerElement: HTMLElement): void => {
  triggerElement.addEventListener('click', (event) => {
    event.preventDefault();
    event.stopPropagation();

    const target = event.target as HTMLElement;

    if (target) {
      const infoToggleWrapper = target.closest('[data-info-toggle]');

      if (infoToggleWrapper) {
        infoToggleWrapper.toggleAttribute(DATA_ATTRIBUTE_ACTIVE);
      }
    }
  });
};

export default InfoToggle;
